///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/task/Agent/Components/AiThinkingIcon"/>
import * as React from "react";

export const AiThinkingIcon = () => (
    <svg height="40" width="40" className="mediusAgent__aiThinkingWrapper apa-loading-indicator" data-testid="apaAgent-aiThinkingIcon">
        <circle className="mediusAgent__aiThinkingWrapper__dot" cx="10" cy="20" r="3" />
        <circle className="mediusAgent__aiThinkingWrapper__dot" cx="20" cy="20" r="3" />
        <circle className="mediusAgent__aiThinkingWrapper__dot" cx="30" cy="20" r="3" />
    </svg>
);